import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAgregarIngresoEgresoReq } from '@core/interfaces/request-response/caja.dto.interface';
import {
  IReporteMovimientoCajaFiltroRq,
  IResumenConReporteMovimientoCajaRes,
} from '@core/interfaces/request-response/movimiento-caja.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class MovimientoCajaApiService extends BaseHttpService {
  agregarIngresoEgreso(rq: IAgregarIngresoEgresoReq) {
    return this.withLoader(
      this.httpClient.post<{ message: string }>(
        `${environment.apiUrl}${environment.apiPreFix}/movimiento-caja/v2/agregar-ingreso-egreso`,
        rq,
      ),
    );
  }
  paginarReporte(rq: IReporteMovimientoCajaFiltroRq, pagina: number, size: number) {
    const params = new HttpParams().set('pagina', pagina.toString()).set('size', size.toString());
    return this.withLoader(
      this.httpClient.post<IResumenConReporteMovimientoCajaRes>(
        `${environment.apiUrl}${environment.apiPreFix}/movimiento-caja/v2/paginar-reporte`,
        rq,
        { params },
      ),
    );
  }

  exportarReporteExcel(rq: IReporteMovimientoCajaFiltroRq) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/movimiento-caja/v2/exportar-reporte-excel`,
        rq,
        {
          observe: 'response',
          responseType: 'blob',
        },
      ),
    );
  }
}
